var PsrProfilePeriodSelect = (function() {
    var cachedDOM = {};

    function cleanOptions() {
        cachedDOM.$select.empty();
    }

    return {
        init: function() {
            cachedDOM.$select = $("#solarRevolutionPeriod");
        },

        populateSelect: function(profile) {
            var currentDate = new Date();
            var profileBirthDate = PsrHelpers.yyyymmddToDate(
                profile.BirthDate,
                profile.BirthTime
            );
            var profileMonthBirth = profileBirthDate.getMonth();
            var profileDayBirth = profileBirthDate.getDate();
            var currentYear = currentDate.getFullYear();
            var yearPeriods = [-1, 0, 1, 2].map(function(value) {
                return value + currentYear;
            });

            cleanOptions();

            cachedDOM.$select.append("<option value=''>Período</option>");

            yearPeriods.map(function(year) {
                var birthDatePeriodStart = new Date(
                    year,
                    profileMonthBirth,
                    profileDayBirth
                );
                var birthDatePeriodEnd = new Date(
                    year + 1,
                    profileMonthBirth,
                    profileDayBirth
                );
                var solarStartPeriod = PsrHelpers.yyyymmddDateFormat(
                    birthDatePeriodStart
                );
                var solarEndPeriod = PsrHelpers.yyyymmddDateFormat(
                    birthDatePeriodEnd
                );
                var $option = $("<option>");
                var optionText =
                    PsrHelpers.yyyymmddToDateFormat(solarStartPeriod) +
                    " a " +
                    PsrHelpers.yyyymmddToDateFormat(solarEndPeriod);

                $option.val(year).text(optionText);

                cachedDOM.$select.append($option);
            });
        },

        getSelectedSolarPeriod: function() {
            return cachedDOM.$select.val();
        }
    };
})();
